import { createReducer, on } from '@ngrx/store';

import * as ProviderActions from './provider.actions';
import { Provider } from '../../../core/domain/provider/provider';
import { IFormMode } from '../../types/IFormMode';

export interface ProviderState {
  isModalOpen: boolean;
  formMode?: IFormMode;
  openedProvider?: Provider;

  providers: Provider[];
}

export const initialState: ProviderState = {
  isModalOpen: false,
  formMode: undefined,
  openedProvider: undefined,

  providers: [],
};

export const providerReducer = createReducer(
  initialState,

  on(ProviderActions.openProviderModal, (state, action) => ({
    ...state,
    isModalOpen: true,
    formMode: action.mode,
    openedProvider: action.provider || undefined,
  })),
  on(ProviderActions.closeProviderModal, (state) => ({
    ...state,
    isModalOpen: false,
    formMode: undefined,
    openedProvider: undefined,
  })),

  on(ProviderActions.loadProviders, (state, action) => ({
    ...state,
    providers: action.providers,
  })),

  on(ProviderActions.createProvider, (state, action) => ({
    ...state,
    providers: [...state.providers, action.provider],
  })),
  on(ProviderActions.updateProvider, (state, action) => ({
    ...state,
    providers: state.providers.map((provider) =>
      provider.id === action.provider.id ? action.provider : provider
    ),
  })),
  on(ProviderActions.deleteProvider, (state, action) => ({
    ...state,
    providers: state.providers.filter(
      (provider) => provider.id !== action.providerId
    ),
  }))
);
